import { State } from 'redux/utils/Delete'

export default State()